module.exports = __webpack_public_path__ + "static/media/lotto90_v1_bg.cf42cd2f.png";